import {
  Cog6ToothIcon,
  HomeIcon,
  UsersIcon,
  UserGroupIcon,
  DocumentTextIcon,
  ClipboardDocumentListIcon,
  QueueListIcon,
  ClipboardDocumentCheckIcon,
  TableCellsIcon,
  FolderIcon,
  ShieldCheckIcon,
  AdjustmentsHorizontalIcon,
  Squares2X2Icon,
  PlusIcon,
  MagnifyingGlassIcon,
  DocumentIcon
} from '@heroicons/react/24/outline';

// Import API service
import api from '../services/api';

// Function to fetch custom pages and add them to navigation
export const fetchCustomPagesForNavigation = async () => {
  try {
    console.log('Fetching custom pages from API...');
    const response = await api.get('/custom-pages');
    console.log('API response:', response.data);

    if (response.data.success) {
      const pages = response.data.data.map(page => ({
        name: page.menuName || page.name,
        path: `custom-page-submissions/${page._id}`,
        element: 'CustomPageSubmissionsTable',
        requiredPermission: 'View Custom Page Submissions',
        customPageId: page._id,
        category: page.menuCategory || 'General'
      }));
      console.log('Mapped pages:', pages);
      return pages;
    }
  } catch (error) {
    console.error('Error fetching custom pages for navigation:', error);
  }
  return [];
};

// Base navigation structure
export const baseNavigation = [
  {
    name: 'New',
    href: '#',
    icon: 'M12 4v16m8-8H4',
    iconComponent: PlusIcon,
    requiredPermissions: ['View Master Data', 'View Tasks', 'View Invoices', 'View Forms'],
    element: null,
    children: [
      {
        name: 'Master Data',
        path: 'new/master-data',
        element: 'MasterDataForm',
        requiredPermission: 'View Master Data',
        iconComponent: FolderIcon
      },
      {
        name: 'Task',
        path: 'new/task',
        element: 'CreateTask',
        requiredPermission: 'View Tasks',
        iconComponent: ClipboardDocumentListIcon
      },
      {
        name: 'Invoice',
        path: 'new/invoice',
        element: 'InvoiceForm',
        requiredPermission: 'View Invoices',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'Forms',
        path: 'new/forms',
        element: 'FormsSelection',
        requiredPermission: 'View Forms',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'Trademark Registration',
        path: 'new/trademark-application',
        element: 'TrademarkApplication',
        requiredPermission: 'Create Trademark Applications',
        iconComponent: DocumentIcon
      }
    ]
  },
  {
    name: 'View & Search',
    href: '#',
    icon: 'M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z',
    iconComponent: MagnifyingGlassIcon,
    requiredPermissions: ['View Master Data', 'View Form Submissions', 'View Tasks', 'View Invoices'],
    element: null,
    children: [
      {
        name: 'Master Data',
        path: 'master-data',
        element: 'MasterDataList',
        requiredPermission: 'View Master Data',
        iconComponent: FolderIcon
      },
      {
        name: 'Form Submissions',
        path: 'form-submissions',
        element: 'FormSubmissions',
        requiredPermission: 'View Form Submissions',
        iconComponent: ClipboardDocumentCheckIcon
      },
      {
        name: 'Tasks',
        path: 'tasks',
        element: 'TaskList',
        requiredPermission: 'View Tasks',
        iconComponent: ClipboardDocumentListIcon
      },
      {
        name: 'Invoices',
        path: 'invoices',
        element: 'InvoiceList',
        requiredPermission: 'View Invoices',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'DOCX Editor',
        path: 'docx-editor',
        element: 'DocxEditor',
        requiredPermission: 'Create Documents',
        iconComponent: DocumentTextIcon
      },
      {
        name: 'Trademark Applications',
        path: 'trademark-applications',
        element: 'TrademarkApplicationsList',
        requiredPermission: 'View Trademark Applications',
        iconComponent: DocumentIcon
      }
    ]
  },
  {
    name: 'Deadlines',
    href: '/forms-and-tasks',
    icon: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z',
    iconComponent: Squares2X2Icon,
    requiredPermissions: ['View Form Submissions'],
    element: 'FormsAndTasks'
  },
  {
    name: 'Admin',
    href: '/admin',
    icon: 'M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z',
    iconComponent: Cog6ToothIcon,
    requiredPermissions: [
      'View Users',
      'View Groups',
      'View Forms',
      'View Client Types',
      'View Products',
      'View Upload Fields',
      'View Verification Types',
      'View Email Gateways',
      'View Admin Settings'
    ],
    element: 'Admin',
    children: [

      {
        name: 'Admin Settings',
        path: 'settings',
        element: 'AdminSettings',
        requiredPermission: 'View Admin Settings',
        iconComponent: AdjustmentsHorizontalIcon,
        children: [
          {
            name: 'Client Types',
            path: 'client-types',
            element: 'ClientTypes',
            requiredPermission: 'View Client Types'
          },
          {
            name: 'Products',
            path: 'products',
            element: 'ProductManagement',
            requiredPermission: 'View Products'
          },
          {
            name: 'Upload Fields',
            path: 'upload-fields',
            element: 'UploadFields',
            requiredPermission: 'View Upload Fields'
          },
          {
            name: 'Verification Types',
            path: 'verification-types',
            element: 'VerificationTypes',
            requiredPermission: 'View Verification Types'
          },
          {
            name: 'Email Gateways',
            path: 'email-gateways',
            element: 'EmailGateways',
            requiredPermission: 'View Email Gateways'
          },
          {
            name: 'Invoice Settings',
            path: 'invoice-settings',
            element: 'InvoiceSettings',
            requiredPermission: 'View Invoice Settings'
          },
          {
            name: 'Email Templates',
            path: 'email-templates',
            element: 'EmailTemplates',
            requiredPermission: 'View Email Templates'
          },
          {
            name: 'Trademark Settings',
            path: 'trademark-settings',
            element: 'TrademarkSettings',
            requiredPermission: 'View Admin Settings'
          },
          {
            name: 'Class Autocomplete Test',
            path: 'class-autocomplete-test',
            element: 'ClassAutocompleteTest',
            requiredPermission: 'View Admin Settings'
          },
          {
            name: 'Form Categories',
            path: 'form-categories',
            element: 'FormCategories',
            requiredPermission: 'View Form Categories'
          },
          {
            name: 'Other Applications',
            path: 'generated-pages',
            element: 'CustomPages',
            requiredPermission: 'View Custom Pages',
            children: [
              {
                name: 'Custom Menu Submissions',
                path: 'custom-menu-submissions',
                element: 'CustomMenuSubmissions',
                requiredPermission: 'View Custom Page Submissions'
              }
            ]
          },
          {
            name: 'Custom Pages',
            path: 'custom-pages',
            element: 'CustomPages',
            requiredPermission: 'View Custom Pages',
          },
          {
            name: 'Checklist Settings',
            path: 'checklist-settings',
            element: 'DocumentVerificationSettings',
            requiredPermission: 'View Admin Settings'
          },
          {
            name: 'Custom Page Documents',
            path: 'custom-documents',
            element: 'CustomDocuments',
            requiredPermission: 'View Custom Page Documents',
            iconComponent: DocumentTextIcon
          },
          {
            name: 'Payment Settings',
            path: 'payment-settings',
            element: 'PaymentSettings',
            requiredPermission: 'View Payment Settings'
          },
          {
            name: 'Document Generation',
            path: 'document-generation',
            element: 'DocumentGeneration',
            requiredPermission: 'View Document Templates',
            iconComponent: DocumentTextIcon
          }
        ]
      },
      { 
        name: 'Users',
        path: 'users',
        element: 'Users',
        requiredPermission: 'View Users',
        iconComponent: UsersIcon
      },

      { 
        name: 'Groups',
        path: 'groups',
        element: 'Groups',
        requiredPermission: 'View Groups',
        iconComponent: UserGroupIcon
      },
      { 
        name: 'Forms',
        path: 'forms',
        element: 'FormsWithCategories',
        requiredPermission: 'View Forms',
        iconComponent: DocumentTextIcon
      },
      { 
        name: 'Checklist', 
        path: 'checklist', 
        element: 'DocumentVerificationList',
        requiredPermission: 'View Admin Settings',
        iconComponent: ShieldCheckIcon
      },
      { 
        name: 'Trademark Settings',
        path: 'trademark-settings',
        element: 'TrademarkSettings',
        requiredPermission: 'View Admin Settings',
        iconComponent: Cog6ToothIcon
      },
      {
        name: 'Document Generation',
        path: 'document-generation',
        element: 'DocumentGeneration',
        requiredPermission: 'View Document Templates',
        iconComponent: DocumentTextIcon
      }
      // { 
      //   name: 'Trademark Settings',
      //   path: 'trademark-settings',
      //   element: 'TrademarkSettings',
      //   requiredPermission: 'View Trademark Settings',
      //   iconComponent: DocumentIcon,
      //   children: [
      //     { 
      //       name: 'Client Types',
      //       path: 'client-types',
      //       element: 'ClientTypes',
      //       requiredPermission: 'View Client Types'
      //     },
      //     { 
      //       name: 'Products',
      //       path: 'products',
      //       element: 'ProductManagement',
      //       requiredPermission: 'View Products'
      //     },
      //     { 
      //       name: 'Upload Fields',
      //       path: 'upload-fields',
      //       element: 'UploadFields',
      //       requiredPermission: 'View Upload Fields'
      //     },
      //     { 
      //       name: 'Verification Types',
      //       path: 'verification-types',
      //       element: 'VerificationTypes',
      //       requiredPermission: 'View Verification Types'
      //     },
      //     {
      //       name: 'Email Gateways',
      //       path: 'email-gateways',
      //       element: 'EmailGateways',
      //       requiredPermission: 'View Email Gateways'
      //     },
      //     {
      //       name: 'Invoice Settings',
      //       path: 'invoice-settings',
      //       element: 'InvoiceSettings',
      //       requiredPermission: 'View Invoice Settings'
      //     },
      //     {
      //       name: 'Email Templates',
      //       path: 'email-templates',
      //       element: 'EmailTemplates',
      //       requiredPermission: 'View Email Templates'
      //     },
      //     {
      //       name: 'Form Categories',
      //       path: 'form-categories',
      //       element: 'FormCategories',
      //       requiredPermission: 'View Form Categories'
      //     },
      //     {
      //       name: 'Other Applications',
      //       path: 'generated-pages',
      //       element: 'CustomPages',
      //       requiredPermission: 'View Custom Pages',
      //       children: [
      //         {
      //           name: 'Custom Menu Submissions',
      //           path: 'custom-menu-submissions',
      //           element: 'CustomMenuSubmissions',
      //           requiredPermission: 'View Custom Page Submissions'
      //         }
      //       ] // This will be populated dynamically
      //     },
      //     {
      //       name: 'Custom Pages',
      //       path: 'custom-pages',
      //       element: 'CustomPages',
      //       requiredPermission: 'View Custom Pages',
      //     },
      //     {
      //       name: 'Checklist Settings',
      //       path: 'checklist-settings',
      //       element: 'DocumentVerificationSettings',
      //       requiredPermission: 'View Admin Settings'
      //     },
      //     {
      //       name: 'Custom Page Documents',
      //       path: 'custom-documents',
      //       element: 'CustomDocuments',
      //       requiredPermission: 'View Custom Page Documents',
      //       iconComponent: DocumentTextIcon
      //     },

      //   ]
      // }
    ]
  }
];

// Function to build complete navigation with custom pages
export const buildNavigation = async () => {
  const navigation = JSON.parse(JSON.stringify(baseNavigation)); // Deep clone

  try {
    console.log('Building navigation with custom pages...');

    // Fetch custom pages
    const customPages = await fetchCustomPagesForNavigation();
    console.log('Fetched custom pages:', customPages);

    // Group custom pages by category
    const groupedPages = {};
    customPages.forEach(page => {
      const category = page.category;
      if (!groupedPages[category]) {
        groupedPages[category] = [];
      }
      groupedPages[category].push(page);
    });

    console.log('Grouped pages:', groupedPages);

    // Find the Custom Pages menu item and add children
    const adminSettings = navigation.find(item => item.name === 'Admin')?.children?.find(child => child.name === 'Admin Settings');
    const customPagesMenu = adminSettings?.children?.find(child => child.name === 'Other Applications');

    console.log('Found custom pages menu:', customPagesMenu);

    if (customPagesMenu) {
      // Add category groups as submenus
      Object.entries(groupedPages).forEach(([category, pages]) => {
        if (pages.length > 0) {
          customPagesMenu.children.push({
            name: category,
            type: 'category',
            children: pages
          });
        }
      });
      console.log('Updated custom pages menu children:', customPagesMenu.children);
    } else {
      console.log('Custom pages menu not found!');
    }
  } catch (error) {
    console.error('Error building navigation with custom pages:', error);
  }
  console.log(navigation);
  return navigation;
};

// Export the base navigation for backward compatibility
export const navigation = baseNavigation; 